import { createAction } from 'redux-actions'

export const applyNowCTAClick = createAction('CREDIT/APPLY_NOW_CTA_CLICK')
export const phoneLinkClick = createAction('BING/PHONE_LINK_CLICK')
export const servicesCheckboxClick = createAction('KENSHOO/SERVICES_CHECKBOX_CLICK')
export const activateGoogleOptimize = createAction('GOOGLE_OPTIMIZE/ACTIVATE')
